<template>
    <div class="table-page">
        <div class="page-toolbar">
            <div class="left">
                <SupsisButton primary @click="showAddWidgetModal">
                    <i class="material-icons">add</i>
                    Widget Ekle
                </SupsisButton>
                <SupsisButton class="ai-suggest-button" @click="showWizard">
                    <img src="/static/img/copilot.png" class="copilot-icon" />
                    Supsis Asistan ile Dashboard Oluştur
                </SupsisButton>
            </div>
            <div class="right"></div>
        </div>

        <div class="layout-container">
            <div class="grid-stack">
                <div
                    v-for="item in layout"
                    :key="item.i"
                    class="grid-stack-item"
                    :gs-x="item.x"
                    :gs-y="item.y"
                    :gs-w="item.w"
                    :gs-h="item.h"
                    :gs-id="item.i"
                >
                    <div class="grid-stack-item-content">
                        <component
                            v-if="isValidWidget(item.i)"
                            :is="getWidgetComponent(getWidgetById(item.i).type)"
                            :widget="getWidgetById(item.i)"
                            :table="table"
                            :upstream-filters="upstreamFilters"
                            @widget-updated="handleWidgetUpdated"
                            @widget-duplicated="handleWidgetDuplicated"
                            @delete="handleDeleteWidget"
                        />
                        <div v-else class="invalid-widget">Widget yüklenemedi</div>
                    </div>
                </div>
            </div>

            <div v-if="!layout.length" class="empty-state">
                <a-empty description="Henüz widget eklenmemiş">
                    <a-button type="primary" @click="showAddWidgetModal"> Widget Ekle</a-button>
                </a-empty>
            </div>
        </div>

        <!-- Widget ekleme modalı -->
        <WidgetCenter 
            :visible="addWidgetModalVisible"
            @close="closeAddWidgetModal"
            @widget-type-selected="selectWidgetType"
        />

        <WidgetAiWizard
            v-if="showWidgetAiWizard"
            :table="table"
            :page="page"
            @widget-added="handleWidgetAdded"
            @close="showWidgetAiWizard = false"
        />
    </div>
</template>

<script>
import Vue from "vue";
import { GridStack } from "gridstack";
import "gridstack/dist/gridstack.min.css";
import ChartWidget from "./charts/ChartWidget.vue";
import NumbersWidget from "./numbers/NumbersWidget.vue";
import IframeWidget from "./iframe/IframeWidget.vue";
import YoutubeWidget from "./youtube/YoutubeWidget.vue";
import TextWidget from "./text/TextWidget.vue";
import CountdownWidget from "./countdown/CountdownWidget.vue";
import { TABLE_API } from "../../../../../api/table";
import SupsisButton from "../../../Settings/components/SupsisButton.vue";
import log2 from "../../../../../utils/log2";
import moment from "moment";
import WidgetAiWizard from "./WidgetAiWizard.vue";
import WidgetCenter from "./WidgetCenter.vue";

const log = log2("TablePage2");

export default Vue.extend({
    name: "TablePage2",
    components: {
        SupsisButton,
        ChartWidget,
        NumbersWidget,
        IframeWidget,
        YoutubeWidget,
        TextWidget,
        CountdownWidget,
        WidgetAiWizard,
        WidgetCenter,
    },
    props: {
        page: {
            type: Object,
            required: true,
        },
        upstreamFilters: {
            type: Object,
            default: () => ({ filters: [], searchQuery: "" }),
        },
        table: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            widgets: [],
            layout: [],
            grid: null,
            addWidgetModalVisible: false,
            newWidgetType: "chart",
            form: this.$form.createForm(this),
            disableGridChangeEvent: false,
            showWidgetAiWizard: false,
        };
    },
    methods: {
        destroyGrid() {
            log("destroyGrid", this.grid);
            if (this.grid) {
                log("destroyGrid.grid exists", this.grid);
                this.grid.destroy(false);
                this.grid = null;
            }
        },
        sleep(ms) {
            return new Promise((resolve) => setTimeout(resolve, ms));
        },

        async initGrid() {
            const isFirstInit = this.grid === null;
            log("initGrid", this.grid);
            this.destroyGrid();
            const options = {
                column: 12,
                minRow: 1,
                cellHeight: 100,
                margin: 10,
                disableOneColumnMode: true,
                float: false,
                animate: true,
                removable: false,
                removeTimeout: 0,
                draggable: {
                    handle: ".widget-header",
                },
                resizable: {
                    handles: "e,se,s,sw,w",
                    autoHide: true,
                },
                alwaysShowResizeHandle: false,
                staticGrid: false,
                noMove: false,
                disableDrag: false,
                disableResize: false,
                minWidth: 100,
                acceptWidgets: false,
            };

            log("initGrid.await this.$nextTick()", {
                options,
            });
            await this.$nextTick();
            if (!isFirstInit) {
                ///await this.sleep(1000 * 60);
            }

            const gridElement = document.querySelector(".grid-stack");
            if (!gridElement) {
                log("Grid element bulunamadı");
                return;
            }

            log("GridStack.init running");
            this.grid = GridStack.init(options, gridElement);
            if (!this.grid) {
                console.error("Grid başlatılamadı");
                return;
            }

            this.grid.on("change", (event, items) => {
                log("grid change triggered", event, items);
                items.forEach((changedItem) => {
                    const existing = this.layout.find((l) => l.i === changedItem.id);
                    if (existing) {
                        existing.x = changedItem.x;
                        existing.y = changedItem.y;
                        existing.w = changedItem.w;
                        existing.h = changedItem.h;
                    }
                });

                log("updateLayoutOnServer calling from grid change", this.layout);
                this.updateLayoutOnServer();
            });
        },
        async loadPage() {
            log("loadPage grid exits = ", this.grid);
            const page = await TABLE_API.getPage(this.table._id, this.page._id);
            if (!page || !page.layout || !Array.isArray(page.layout)) {
                console.error("Geçersiz sayfa verisi:", page);
                return;
            }

            this.widgets = page.layout.map((item) => item.widget);
            this.layout = page.layout.map((item) => ({
                x: parseInt(item.x) || 0,
                y: parseInt(item.y) || 0,
                w: parseInt(item.w) || 6,
                h: parseInt(item.h) || 2,
                i: item.widget._id,
            }));

            await this.$nextTick();

            // Grid'i güncelle
            await this.$nextTick();
            this.initGrid();
        },
        async updateLayoutOnServer() {
            try {
                if (this.disableGridChangeEvent) {
                    log("updateLayoutOnServer.disableGridChangeEvent");
                    return;
                }
                log("updateLayoutOnServer", this.layout);
                await TABLE_API.updateTablePage(this.table._id, this.page._id, {
                    layout: this.layout.map((item) => ({
                        x: parseInt(item.x),
                        y: parseInt(item.y),
                        w: parseInt(item.w),
                        h: parseInt(item.h),
                        widget: item.i,
                    })),
                });
            } catch (error) {
                console.error("Layout güncellenirken hata oluştu", error);
                this.$message.error("Layout güncellenirken hata oluştu");
            }
        },
        isValidWidget(widgetId) {
            const widget = this.getWidgetById(widgetId);
            return widget && widget.type && this.getWidgetComponent(widget.type);
        },
        getWidgetComponent(type) {
            if (!type) return null;
            const components = {
                chart: "ChartWidget",
                numbers: "NumbersWidget",
                iframe: "IframeWidget",
                youtube: "YoutubeWidget",
                text: "TextWidget",
                countdown: "CountdownWidget",
                // Diğer widget tipleri için component mapping'leri buraya eklenecek
            };
            return components[type] || null;
        },
        getWidgetById(widgetId) {
            if (!widgetId) return null;
            return this.widgets.find((w) => w._id === widgetId) || null;
        },
        showAddWidgetModal() {
            this.addWidgetModalVisible = true;
        },
        closeAddWidgetModal() {
            this.addWidgetModalVisible = false;
            this.newWidgetType = "chart";
        },
        async handleDeleteWidget(widgetId) {
            try {
                await TABLE_API.deleteWidget(this.table._id, this.page._id, widgetId);
                this.widgets = this.widgets.filter((w) => w._id !== widgetId);
                this.layout = this.layout.filter((item) => item.i !== widgetId);
                const node = this.grid.engine.nodes.find((n) => n.id === widgetId);
                if (node) {
                    this.grid.removeWidget(node.el);
                }
                await this.updateLayoutOnServer();
                this.$message.success("Widget başarıyla silindi");
            } catch (error) {
                console.error("Widget silinirken hata oluştu", error);
                this.$message.error("Widget silinirken hata oluştu");
            }
        },
        handleWidgetUpdated(updatedWidget) {
            const widgetIndex = this.widgets.findIndex((w) => w._id === updatedWidget._id);
            if (widgetIndex !== -1) {
                this.widgets.splice(widgetIndex, 1, updatedWidget);
            }
        },
        async handleWidgetDuplicated({ widget, page }) {
            log("handleWidgetDuplicated", { widget, page });
            this.widgets.push(widget);
            const newLayout = page.layout.map((item) => ({
                x: item.x,
                y: item.y,
                w: item.w,
                h: item.h,
                i: item.widget?._id || item.widget,
            }));
            log("handleWidgetDuplicated.newLayout", newLayout);
            const newItem = newLayout.find((item) => item.i === widget._id);
            log("handleWidgetDuplicated.newItem", newItem);
            if (newItem) {
                this.disableGridChangeEvent = true;

                const node = {
                    x: newItem.x,
                    y: newItem.y,
                    w: newItem.w,
                    h: newItem.h,
                    id: newItem.i,
                    content: "",
                };
                log("handleWidgetDuplicated.addWidget", node);
                //this.grid.addWidget(node);
                setTimeout(() => {
                    this.initGrid();
                }, 500);
                setTimeout(() => {
                    this.disableGridChangeEvent = false;
                }, 1000);
            }

            this.layout = newLayout;

            await this.$nextTick();
            //this.grid.makeWidget(document.querySelector(`.grid-stack-item[gs-id="${newItem.i}"]`));
        },
        async addNewWidget() {
            try {
                let defaultSettings = {};
                if (this.newWidgetType === "countdown") {
                    defaultSettings = {
                        targetDate: moment().add(1, "day").toDate(),
                        showUnits: {
                            months: false,
                            weeks: false,
                            days: false,
                            hours: true,
                            minutes: true,
                            seconds: true,
                        },
                        style: {
                            backgroundColor: "#ffffff",
                            textColor: "#000000",
                            fontSize: 48,
                            labelFontSize: 16,
                        },
                    };
                }

                const widget = await TABLE_API.createWidget(this.table._id, this.page._id, this.newWidgetType, {
                    title: "Yeni Widget",
                    settings: defaultSettings,
                });

                this.widgets.push(widget);
                const position = this.calculateNewWidgetPosition();

                const newLayoutItem = {
                    x: position.x,
                    y: position.y,
                    w: 6,
                    h: this.newWidgetType === "youtube" ? 4 : 2, // YouTube widget'ı için daha yüksek
                    i: widget._id,
                };

                this.layout.push(newLayoutItem);

                await this.$nextTick();
                this.grid.makeWidget(document.querySelector(`.grid-stack-item[gs-id="${widget._id}"]`));

                await this.updateLayoutOnServer();
                this.closeAddWidgetModal();
                this.$message.success("Widget başarıyla eklendi");
                
                // Widget'a scroll ol
                this.scrollToWidget(widget._id);
                
                // 1.5 saniye sonra widget'ın ayar modalını aç
                setTimeout(() => {
                    this.openWidgetSettings(widget._id);
                }, 1500);
            } catch (error) {
                console.error("Widget eklenirken hata oluştu", error);
                this.$message.error("Widget eklenirken hata oluştu");
            }
        },
        calculateNewWidgetPosition() {
            if (!this.layout.length) {
                return { x: 0, y: 0 };
            }

            const maxY = Math.max(...this.layout.map((item) => item.y + item.h));
            const lastRowWidgets = this.layout.filter((item) => item.y + item.h === maxY);
            const totalWidthInLastRow = lastRowWidgets.reduce((sum, item) => sum + item.w, 0);

            if (totalWidthInLastRow + 6 <= 12) {
                const lastX = Math.max(...lastRowWidgets.map((item) => item.x + item.w), 0);
                return { x: lastX, y: lastRowWidgets[0]?.y || 0 };
            }

            return { x: 0, y: maxY };
        },
        showWizard() {
            this.showWidgetAiWizard = true;
        },
        handleWidgetAdded(widget) {
            this.widgets.push(widget);
            const position = this.calculateNewWidgetPosition();

            const newLayoutItem = {
                x: position.x,
                y: position.y,
                w: 6,
                h: widget.type === "youtube" ? 4 : 4,
                i: widget._id,
            };

            this.layout.push(newLayoutItem);

            this.$nextTick(() => {
                this.grid.makeWidget(document.querySelector(`.grid-stack-item[gs-id="${widget._id}"]`));
                
                // Widget'a scroll ol
                this.scrollToWidget(widget._id);
                
                // AI Wizard ile eklenen widget'lar için ayar modalını açmıyoruz
                // Çünkü Wizard ile birden fazla widget art arda eklendiğinde
                // her biri için ayar modalı açılması kullanıcı deneyimini bozabilir
            });

            this.updateLayoutOnServer();
        },
        selectWidgetType(type) {
            this.newWidgetType = type;
            this.addNewWidget();
        },
        scrollToWidget(widgetId) {
            const widgetElement = document.querySelector(`.grid-stack-item[gs-id="${widgetId}"]`);
            if (widgetElement) {
                widgetElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        },
        openWidgetSettings(widgetId) {
            const widgetComponent = this.$children.find(child => {
                return child.$options.name && 
                       ['ChartWidget', 'NumbersWidget', 'IframeWidget', 'YoutubeWidget', 'TextWidget', 'CountdownWidget'].includes(child.$options.name) && 
                       child.widget && 
                       child.widget._id === widgetId;
            });
            
            if (widgetComponent) {
                widgetComponent.handleEdit();
            }
        },
    },
    async mounted() {
        await this.loadPage();
    },
    beforeDestroy() {
        if (this.grid) {
            this.grid.destroy();
        }
    },
    watch: {
        page: {
            handler(newPage) {
                if (newPage && newPage._id) {
                    this.loadPage();
                }
            },
            immediate: true,
        },
    },
});
</script>

<style lang="scss" scoped>
$footer-height: 40px;
.table-page {
    height: calc(100vh - 194px + $footer-height - 1px) !important;
    max-height: calc(100vh - 194px + $footer-height - 1px) !important;
    display: flex;
    flex-direction: column;

    .page-toolbar {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 16px 24px;
        background-color: #fff;
        border-bottom: 1px solid #e8e8e8;
        flex-shrink: 0;
        .left {
            display: flex;
            gap: 10px;
            .ai-suggest-button {
                .copilot-icon {
                    vertical-align: middle;
                    margin-right: 0px;
                    width: 15px;
                    height: 15px;
                }
            }
        }

        .right {
            display: flex;
            gap: 10px;
        }
    }

    .layout-container {
        flex: 1;
        padding: 24px;
        background-color: #f6f7fb;
        overflow-y: auto;

        .grid-stack {
            background: transparent;
            min-height: calc(100vh - 200px);
        }

        .grid-stack-item {
            background: #fff;
            border-radius: 4px;
            box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
            transition: box-shadow 0.3s ease;

            &:hover {
                box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
            }

            .grid-stack-item-content {
                inset: 5px;
                background: #fff;
                border-radius: 4px;
                overflow: hidden;
            }
        }
    }

    .empty-state {
        display: flex;
        justify-content: center;
        align-items: center;
        min-height: 400px;
        background-color: #f6f7fb;
        border-radius: 4px;
    }
}

// Gridstack özel stilleri
.grid-stack-item {
    background: transparent !important;
    box-shadow: none !important;
}
.grid-stack > .grid-stack-item > .grid-stack-item-content {
    overflow-y: hidden;
}

.grid-stack > .grid-stack-item > .ui-resizable-handle {
    background-image: none !important;
    &::after {
        content: "";
        position: absolute;
        right: 3px;
        bottom: 3px;
        width: 5px;
        height: 5px;
        border-right: 2px solid rgba(0, 0, 0, 0.4);
        border-bottom: 2px solid rgba(0, 0, 0, 0.4);
    }
}

.invalid-widget {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    background-color: #fafafa;
    color: #999;
    font-size: 14px;
    border: 1px dashed #ddd;
    border-radius: 4px;
}
</style>
